import { String } from "@silvertours/front-shared";
import { addDays } from "date-fns/addDays";
import { format } from "date-fns/format";
export var isDeptDateInLessThanDays = function(depDate, days) {
    return new Date(depDate) <= addDays(new Date(), days);
};
export var isDestDateBeforeDepDate = function(destDate, depDate) {
    return new Date(destDate) <= new Date(depDate);
};
export var isSearchInCuba = function(dep, dest) {
    return (dep === null || dep === void 0 ? void 0 : dep.countryCode) === "CU" || (dest === null || dest === void 0 ? void 0 : dest.countryCode) === "CU";
};
export var formatDate = function(date) {
    return format(date, String.isoDateTimeWithSeconds);
};
